import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrencesByGenderAnually = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Resultado das ocorrências anuais por gênero'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByGenderAnually?.categories}
            series={chartData?.ocurrencesByGenderAnually?.series}
            stacked
            customColors={['#FF4560','#008FFB', '#00E396']}
        />
    );
};